var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscovery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, "Distributor Map (A.P.A.C)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.9999 11.9999C21.9999 17.5229 17.5229 21.9999 11.9999 21.9999C6.4769 21.9999 1.9999 17.5229 1.9999 11.9999C1.9999 6.4779 6.4769 1.9999 11.9999 1.9999C17.5229 1.9999 21.9999 6.4779 21.9999 11.9999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8598 8.7049L14.2398 13.8249C14.1798 14.0349 14.0098 14.2049 13.7998 14.2659L8.6998 15.8649C8.3598 15.9759 8.0298 15.6449 8.1398 15.3049L9.7398 10.1749C9.7998 9.9649 9.9698 9.8049 10.1798 9.7349L15.2998 8.1349C15.6498 8.0249 15.9698 8.3549 15.8598 8.7049Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.283637ff3d31c3c3891dbdb58c98563d.svg";
export { ForwardRef as ReactComponent };